import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, greenMui, purpleMui } from "@ryde/theme";

export const EntityHeaderStyled = styled.header.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "entity-header-styled",
})`
  align-items: center;

  .EntityHeader-Item {
    color: ${blueGreyMui._500};
    font-size: 12px;
    font-weight: 500;
  }

  .EntityHeader-Emoji {
    margin-inline-start: 4px;
  }

  .audit-log-metadata-labels {
    margin-inline-start: 6px;
    font-size: 11px;
  }

  .EntityHeader-Metadata {
    font-weight: 500;
    margin-inline-start: 0;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 11px;
    display: inline-block;
    border: 1px solid;

    &.EntityHeader-Metadata--created {
      background-color: ${greenMui._50};
      color: ${greenMui._700};
      border-color: ${greenMui._200};
    }

    &.EntityHeader-Metadata--deleted {
      background-color: ${purpleMui._50};
      color: ${purpleMui._700};
      border-color: ${purpleMui._200};
    }

    &.EntityHeader-Metadata--updated {
      background-color: ${blueMui._50};
      color: ${blueMui._700};
      border-color: ${blueMui._200};
    }

    &.EntityHeader-Metadata--syncer-push {
      background-color: ${purpleMui._100};
      color: ${purpleMui._800};
      border-color: ${purpleMui._300};
    }
  }
`;
